import Account from "@/components/common/account/index.tsx";

export default function Billing() {
  return <Account />;
}
